import React, { FunctionComponent } from 'react';
import Text, { TextSize, TextBasicProps, TextCommonProps } from 'components/typography/text';

type Header2Props = TextBasicProps & TextCommonProps;

const Header2: FunctionComponent<Header2Props> = (props) => {
    const { children, align, color, isInline, hasEllipsis, hasBreakWords, isDangerous, tag } =
        props;

    return (
        <Text
            size={TextSize.HEADER2}
            align={align}
            color={color}
            isInline={isInline}
            hasEllipsis={hasEllipsis}
            hasBreakWords={hasBreakWords}
            isDangerous={isDangerous}
            tag={tag}
        >
            {children}
        </Text>
    );
};

export default Header2;
